<div class="container" *ngIf="!fetching">
  <div *ngIf="!GetQuotingAvailability().isDisabled">
    <section class="no-results" *ngIf="this.quote?.quoteState === quoteStateType.NO_RESULT">
      <p>
        <strong>Sorry! No prices were returned for your search.</strong><br />
        Try widening your search or using different utility account details.
      </p>
    </section>
    <section class="no-results" *ngIf="this.quote?.quoteState === quoteStateType.INVALIDATED && this.quote?.quoteRequestState?.status !== 'QuoteRequested' && this.quote?.quoteRequestState.status !== 'RefreshRequested'">
      <p><br /></p>
    </section>
    <section class="no-results" *ngIf="this.quote?.quoteState === quoteStateType.REQUESTED">
      <p>
        <strong>You requested a quote on {{ this.date$ | async | date: dateFormat }}</strong><br />
        Your quote request exceeded the maximum usage limit for a quote. Your request will be reviewed and responded to shortly. Please check
        back again soon!
      </p>
    </section>
    <section class="no-results" *ngIf="this.quote?.quoteState === quoteStateType.BROKER_REQUESTED">
      <p>
        <strong>You requested a quote on {{ this.date$ | async | date: dateFormat }}</strong><br />
        Your request will be reviewed and responded to shortly. Please check back again soon!
      </p>
    </section>
    <section class="no-results" *ngIf="this.quote?.quoteState === quoteStateType.BROKER_REQUESTED_UNQUOTED">
      <p>
        <strong>You have not completed all the fields required for an instant quote</strong>
        <br />
        Please ensure all fields (including any answered with "I don't know") have been completed with the correct<wbr />
        customer and meter information.
      </p>
    </section>
    <section class="no-results" *ngIf="this.quote?.quoteState === quoteStateType.ERROR">
      <p>
        <strong>{{ quote?.error.error }}</strong><br />{{ quote?.error.detail }}
      </p>
    </section>
    <section class="no-results" *ngIf="this.quote?.quoteState === quoteStateType.EXPIRED && this.quote?.quoteRequestState?.status !== 'QuoteExpiredUnderReview'">
      <p><strong>Sorry! Your quote has expired.</strong><br />Click Quote to generate a new one.</p>
    </section>

    <section class="no-results" *ngIf="this.quote?.quoteState === quoteStateType.EXPIRED && this.quote?.quoteRequestState?.status === 'QuoteExpiredUnderReview'">
      <p><strong>Sorry! quote has expired for the day.</strong><br />Click Quote to generate a new one.</p>
    </section>

    <section class="no-results" *ngIf="this.quote?.quoteState === quoteStateType.INVALIDATED && (this.quote?.quoteRequestState?.status === 'QuoteRequested' || this.quote?.quoteRequestState.status === 'RefreshRequested')">
      <p><strong>No Quote has been requested</strong><br />Click Quote to generate one.</p>
    </section>

    <section class="no-results padLeftAndRight" *ngIf="this.quote?.quoteState === quoteStateType.HAS_I_DONT_KNOWS">
      <p>
        <strong>You have not completed all the fields required for an instant quote</strong>
        <br />
        Please ensure all fields (including any answered with "I don't know") have been completed with the correct<wbr /> customer and meter
        information and try again, or click the <strong>Request a Quote</strong> button below so that the <wbr />
        supplier can complete these for you and respond with a quote.
      </p>
    </section>


  </div>

  <div *ngIf="GetQuotingAvailability().isDisabled">
    <section class="no-results">
      <p>
        <strong>Quoting is done for the {{GetQuotingAvailability().disabledType}}</strong><br />
        Please come back next {{GetQuotingAvailability().disabledType}} and try again!
      </p>
    </section>
  </div>
  <ng-content class="no-results" select="[additional-quote-status-message]"></ng-content>
</div>
